import React from "react";
import FilterIcon from "assets/images/icons/filter.svg";
import useTranslation from "../../hooks/useTranslation";

const Index = ({
  hasFilter = false,
  className = "",
  handleClick,
  title = "Фильтровать",
}) => {
  const { tr } = useTranslation();

  return (
    <button
      type={"button"}
      className={`d-btn d-btn--small fs-14 d-btn-default --signal-block ${className}`}
      onClick={() => handleClick()}
    >
      {hasFilter && (
        <span className="--signal" style={{ top: "-5px", right: "5px" }}></span>
      )}
      <img src={FilterIcon} alt="" className="mr-10" />
      {tr(title)}
    </button>
  );
};

export default Index;
